import { useOrgResolvedFlag } from '~/hooks/useOrgResolvedFlag';
import { UTILITIES_PAGE_REDESIGN_FLAG } from './common';

/** True once the active org's flags have loaded and `utilities-page-redesign` is on for it. */
export function useUtilitiesPageRedesignEnabled(): boolean {
  const { resolved, enabled } = useOrgResolvedFlag(UTILITIES_PAGE_REDESIGN_FLAG);
  return resolved && enabled;
}
